<div class="panel" [class.visible]="hasAny">
  <div class="header">{{ 'CONFLICTS' | translate }} ({{ totalInstanceCount }})</div>
  <div *ngFor="let invalidPanel of conflicts.invalidPanels" class="collision">
    <img src="assets/svg/icon-error.svg" />
    <div class="text">
      <div class="title">
        {{ 'INVALID_PANEL.TITLE' | translate | replace: '[SIZE]' : invalidPanel.size }}
        <span *ngIf="invalidPanel.count > 1">({{ invalidPanel.count }})</span>
      </div>
      <div>{{ 'INVALID_PANEL.DETAIL' | translate | replace: '[SIZE]' : invalidPanel.size }}</div>
    </div>
  </div>
  <div *ngFor="let collision of conflicts.collisions" class="collision">
    <img src="assets/svg/icon-error.svg" />
    <div class="text">
      <div class="title">{{ getTitleForCollision(collision) }}</div>
      <div>{{ getATextForCollision(collision) }}</div>
      <div>{{ getBTextForCollision(collision) }}</div>
    </div>
  </div>
  <div class="footer">
    {{ 'CONFLICTS_RESOLVE' | translate }}
  </div>
</div>
